<h3 mat-dialog-title>Förhandsgranskning av resultat</h3>
<mat-dialog-content>
  <div class="alert alert-info mx-2">
    <div [innerHTML]="blueBox"></div>
  </div>

  @for (chartDefinition of charts; track $index) {
    <div class="mb-3">
      <wfs-dynamic-form-chart-wrapper
        [chart]="chartDefinition"
        [answers]="chartData[$index]"
        [series]="series[$index]"
        [labels]="
          chartDefinition.type === ChartType.LineChart ? lineChartLabels : labels[$index]
        "></wfs-dynamic-form-chart-wrapper>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="justify-content-end pe-4 border-top">
  <wfs-form-button
    (buttonClicked)="close()"
    [label]="'Stäng'"
    [buttonStyle]="'warning'" />
</mat-dialog-actions>
